import { useSearchParams } from 'react-router-dom';
import { useLegalEntityRegions } from '../../../../hooks/useUser';
import { RegionFilter } from './RegionFilter';

export const SelectedRegionFilter = () => {
  const regions = useLegalEntityRegions();
  const [searchParams] = useSearchParams();
  const locationId = searchParams.get('location_id');

  const selectedRegion = regions.find(
    ({ code }) => code === locationId?.toUpperCase(),
  );

  if (selectedRegion) {
    return (
      <li data-static-list-item="true" className="hidden sm:block">
        <RegionFilter region={selectedRegion.region} />
      </li>
    );
  }

  return null;
};
